import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import { PaziaFormButton } from "components/atoms";

import { CourseScheduleDetailsApi } from "api";
import { CourseSessionOption } from "api/hooks";
import { BaseScheduleForm, BaseScheduleFormSchema, ScheduleFormBase } from "./BaseScheduleForm";

interface ScheduleFormProps {
  onSubmit: (data: BaseScheduleFormSchema) => Promise<void>;
  sessionsOptions: CourseSessionOption[];
  item?: CourseScheduleDetailsApi;
  formStyle: React.CSSProperties;
  formClassName?: string;
}

export const ScheduleBreakForm = ({
  sessionsOptions,
  item,
  onSubmit,
  formStyle,
  formClassName,
}: ScheduleFormProps): JSX.Element => {
  const methods = useForm({
    // @ts-ignore TODO
    resolver: yupResolver(ScheduleFormBase.schema),
    defaultValues: {
      ...ScheduleFormBase.resolveDefaultValues(item?.schedule),
    },
  });
  const { handleSubmit, reset } = methods;

  const onSubmitHandler = async (data: BaseScheduleFormSchema) => {
    await onSubmit(data);
    reset(
      {},
      {
        keepErrors: false, // This ensures errors are cleared
        keepDirty: false,
        keepIsSubmitted: false,
        keepTouched: false,
        keepIsValid: false,
        keepSubmitCount: false,
      },
    );
  };

  return (
    <FormProvider {...methods}>
      {/* @ts-ignore */}
      <form onSubmit={handleSubmit(onSubmitHandler)} className="flex grow flex-col justify-between">
        <div className={` ${formClassName}`} style={formStyle}>
          <BaseScheduleForm sessionsOptions={sessionsOptions} />
        </div>
        <div className="mt-8 flex justify-end">
          <PaziaFormButton title={item ? "Zapisz zmiany" : "Dodaj przerwę"} type="success" />
        </div>
      </form>
    </FormProvider>
  );
};
